<template>
    <v-layout id="root">
        <slot></slot>
        <div id="overlay" class="justify-center align-center" v-show="value" :style="{display: 'flex', background: showOverlay ? '#FFFFFFD0' : 'none'}">
            <Spin></Spin>
        </div>
    </v-layout>
</template>

<script>
  import { sendAnalyticsEvent } from '@/plugins/googleAnalytics'

  export default {
    name: 'Loading',
    props: {
      value: Boolean,
      fixed: Boolean,
      showOverlay: {
        default: true,
        type: Boolean
      },
      size: {
        default: 80,
        type: Number
      },
      width: {
        default: 7,
        type: Number
      }
    },
    data: () => ({
      elapsedTime: 0.0,
      interval: undefined
    }),
    watch: {
      value (visible) {
        if (visible) {
          document.documentElement.style.overflow = 'hidden'
          this.interval = setInterval(() => { this.elapsedTime += 0.1 }, 100)
          sendAnalyticsEvent(this.$gtag, 'virtual_page_view')
        }

        if (!visible) {
          document.documentElement.style.overflow = 'auto'
          clearInterval(this.interval)
          this.interval = undefined

          sendAnalyticsEvent(
            this.$gtag,
            'virtual_page_view',
            { tempo_carregamento: this.elapsedTime }
          )

          this.elapsedTime = 0
        }
      }
    }
  }
</script>

<style scoped>
    #root {
        position: relative;
    }

    #overlay {
        position: fixed;
        top: 0;
        right: 0;
        bottom: 0;
        left: 0;
        z-index: 9999999;
        user-select: none;
    }

</style>
